import {
  Collaborator,
  CollaboratorType,
  UserAchievementTier,
} from "@kaggle/sdk/users";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

const DEFAULT_OWNER: Collaborator = {
  name: "",
  thumbnailUrl: "",
  profileUrl: "",
  slug: "",
  userTier: UserAchievementTier.NOVICE,
  joinDate: undefined,
  type: CollaboratorType.READER,
};

export const owner = (
  state: Collaborator = DEFAULT_OWNER,
  action: NotebookAction
): Collaborator => {
  switch (action.type) {
    case NotebookActionKey.SET_OWNER:
      return action.payload.owner;
    default:
      return state;
  }
};
